module.exports = __webpack_public_path__ + "static/media/breeam.18d7ccef.png";